import React from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./Profile.css";
import airplaneImage from "../../assets/airplane.png";
import logo from "../../assets/logo.png";
import {
  FaTimes,
  FaBars,
  FaTable,
  FaGlobe,
  FaMobileAlt,
  FaSignOutAlt,
  FaQuestionCircle,
  FaUserCircle,
} from "react-icons/fa";

function Profile() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = React.useState(false);
  const [showHelp, setShowHelp] = React.useState(false);
  const toggleHelp = () => setShowHelp((prev) => !prev);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="layout-wrapper">
      {/* Top Header */}
      <header className="top-bar" style={{ position: "relative" }}>
        <div className="sidebar-top-row" style={{ position: "absolute", left: 20, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center" }}>
          {!collapsed && (
          <img onClick={() => navigate("/home")} src={logo} alt="Logo" className="sidebar-logo" style={{ height: 38, width: 38, objectFit: 'contain', cursor: 'pointer', marginRight: 18 }} />
          )}
          <button
            className="menu-btn sidebar-menu-btn"
            onClick={() => setCollapsed((prev) => !prev)}
            aria-label="Toggle sidebar"
            style={{ marginLeft: !collapsed ? 0 : 0 }}
          >
            <FaBars size={24} />
          </button>
        </div>
        <h1 className="portal-title" style={{ margin: 0, position: "absolute", left: 0, right: 0, textAlign: "center", pointerEvents: "none" }}>Lounge Atlas Portal</h1>
        <div style={{ position: "absolute", right: 20, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 12 }}>
          <button className="class1-btn" >
            <FaUserCircle size={24} style={{ color: "#2b3a55" }} />
          </button>
          <button className="class1-btn" onClick={toggleHelp}>
            <FaQuestionCircle size={20} />
          </button>
        </div>
      </header>

      {/* Body */}
      <div className="body-section">
        {/* Sidebar */}
        <aside className={`side-panel ${collapsed ? "collapsed" : ""}`} style={{ margin: "0px 0px 0px 0px" }}>
          {/* Airplane image (below logo/menu row) */}
          {!collapsed && (
            <div className="sidebar-image">
              <img src={airplaneImage} alt="Airplane" />
            </div>
          )}

          <nav className="side-menu">
            <button onClick={() => navigate("/tables")}> <FaTable /> {!collapsed && <span>App Management</span>} </button>
            <button onClick={() => openInNewTab("https://ieg-america.com/")}> <FaGlobe /> {!collapsed && <span>IEG Website</span>} </button>
            <button onClick={() => openInNewTab("https://app.loungeatlas.com/")}> <FaMobileAlt /> {!collapsed && <span>Lounge Atlas App</span>} </button>
            <button onClick={handleLogout}> <FaSignOutAlt /> {!collapsed && <span>Sign Out</span>} </button>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="main-panel">
          <div className="profile-card">
            <div className="profile-avatar">
              <FaUserCircle size={80} />
            </div>
            
            <h2 className="profile-title">Profile Information</h2>
            <div className="profile-details">
  
              <div className="profile-row">
                <span className="profile-label">First Name:</span>
                <span className="profile-value">{currentUser?.first_name || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">Last Name:</span>
                <span className="profile-value">{currentUser?.last_name || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">User ID:</span>
                <span className="profile-value">{currentUser?.user_id || currentUser?.email || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">Organization:</span>
                <span className="profile-value">{currentUser?.organization || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">City:</span>
                <span className="profile-value">{currentUser?.city || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">Country:</span>
                <span className="profile-value">{currentUser?.country || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">Phone:</span>
                <span className="profile-value">{currentUser?.mobile_number || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">Role:</span>
                <span className="profile-value">{currentUser?.role || "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">Created At:</span>
                <span className="profile-value">{currentUser?.created_at ? new Date(currentUser.created_at).toLocaleString() : "N/A"}</span>
              </div>
              <div className="profile-row">
                <span className="profile-label">Updated At:</span>
                <span className="profile-value">{currentUser?.updated_at ? new Date(currentUser.updated_at).toLocaleString() : "N/A"}</span>
              </div>
            </div>
          </div>
        </main>
      </div>

      {showHelp && (
        <>
          <div className="overlay-backdrop" onClick={toggleHelp}></div>
          <div className="help-overlay">
            <h2>Need Help?</h2>
            <p><strong>Phone:</strong> +1 (514) 871-4910</p>
            <p><strong>Email:</strong> support@loungeatlas.com</p>
            <button className="close-icon" onClick={toggleHelp}>
              <FaTimes size={20} />
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default Profile;
